import React from "react";
import { DatePicker as AntdDatePicker } from "antd";
import moment from "moment";

const DatePicker = ({
	defaultValue,
	dispatch,
	name,
	format,
	isNew,
	dataType,
	questionId,
	outputFormat = "YYYY-MM-DD",
	disabledDate,
	...otherProps
}) => {
	//data is stored in ISO format, rendered in local format
	const dateValue = defaultValue
		? moment(defaultValue, "YYYY-MM-DD HH:mm")
		: null;
	const renderDateValue = dateValue ? moment(dateValue, format) : null;
	const [answerAdded, answerEdited] = dispatch;
	const handleDispatch = (e, date) => {
		let data = {
			questionId: questionId,
			value: date ? moment(date, format).format(outputFormat) : null,
			id: name,
		};
		if (!isNew) answerEdited(data);
		else answerAdded(data);
	};
	return (
		<AntdDatePicker
			allowClear={true}
			showTime={dataType === "datetime"}
			format={format}
			defaultValue={renderDateValue}
			onChange={handleDispatch}
			name={name}
			{...otherProps}
			suffixIcon={null}
			disabledDate={disabledDate}
		/>
	);
};

export default DatePicker;
